import React from "react";
import { DeploymentUnitOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";

// types
import { IChart } from "@src/types/chart";

import { AxesPivot } from "./pivot/axes-pivot";

type IProps = {
  layout: IChart;
  setPivotConfig?: React.Dispatch<any>;
};

function PivotGroup({ layout, setPivotConfig }: IProps) {
  const pivotRef = React.useRef<any>(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
    pivotRef.current.updatePivot();
    setPivotConfig?.(pivotRef.current.getNewPivot());
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    pivotRef.current.resetPivot();
  };

  return (
    <>
      <Button icon={<DeploymentUnitOutlined />} size="small" onMouseDown={showModal}>
        Pivot
      </Button>
      <Modal title="Pivot" className="modal-amanotes" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <div className="pivot-popover">
          <div data-testid="pivot-popover" className=" w-full">
            <AxesPivot ref={pivotRef} layout={layout} />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default PivotGroup;
